import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "react-material-ui-carousel";
import background from "../../resources/mediabackground.jpg";
import { logFunctions as log } from "../../util/Logging";

export default function ImageCarousel(props) {
  const carouselInterval = 10000; // constant (in milliseconds) - how long to stay on each image in carousel
  const carouselDuration = 700; // constant (in milliseconds) - how long to change images

  const [items, setItems] = useState([]);
  const url =
    window.ASSETSURL +
    "/" +
    localStorage.getItem("orgID") +
    "/" +
    localStorage.getItem("siteID") +
    "/kioskCustomStyles/config.json";

  useEffect(() => {
    log.debug("+ImageCarousel_useEffect(TRACE)");
    log.info("ImageCarousel_useEffect() => Getting images from url: " + url);
    const getImages = async () => {
      axios
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.carouselAssets !== undefined) {
            log.info(
              "ImageCarousel_useEffect() => Successfully loaded carousel assets"
            );
            setItems(res.data.carouselAssets);
          } else {
            log.info(
              "ImageCarousel_useEffect() => Carousel assets not found - using default background"
            );
            setItems([
              {
                sourceUrl: background,
                imgName: "defaultMediaBackgroundImg",
                styles: { objectPosition: "0 -90px" },
              },
            ]);
          }
        })
        .catch((err) => {
          log.error(
            "ImageCarousel_useEffect() => Error Occurred while getting carousel images: " +
              err
          );
          setItems([
            {
              sourceUrl: background,
              imgName: "defaultMediaBackgroundImg",
              styles: { objectPosition: "0 -90px" },
            },
          ]);
        });
    };

    getImages();
    log.debug("-ImageCarousel_useEffect(TRACE)");
  }, [url]);

  return (
    <Carousel
      id="imageCarousel"
      className="carousel"
      animation="fade"
      indicators={false}
      navButtonsAlwaysInvisible={true}
      swipe={false}
      duration={carouselDuration}
      interval={carouselInterval}
    >
      {items.map((item, i) => (
        <img
          id={item.imgName}
          key={i}
          src={item.sourceUrl}
          alt={item.imgName}
          style={item.styles}
        />
      ))}
    </Carousel>
  );
}
